import { faCalendarCheck, faChartBar, faDownload, faMedal, faShoppingCart, faUser, faKey, faWalking } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../../assets/images/logo-thumb.png';
import { t } from '../../../helpers/translation_helper';
import './navbar.css';

/**
 * Navigation Bar Partial Component
 */
class NavBar extends Component {
  // Render Component
  render() {
    return (
      <aside id='navbar'>
        <div className='blue-bar'>
          <div className='logo'>
            <Link to='/dashboard' title={t('Dashboard')}>
              <div
                className='logo'
                style={{
                  backgroundImage: 'url(' + this.props.authData.centerData.logo + ')',
                  backgroundSize: '100% auto',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                  marginBottom: 10,
                }}></div>
            </Link>
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            width: '100%'
          }}>
            <ul>
              <li>
                <NavLink activeclassname='active' to='/download-media' title={t('Media')}>
                  <FontAwesomeIcon icon={faDownload} color='#ffffff' />
                  <div>{t('Media')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/profile' title={t('Profile')}>
                  <FontAwesomeIcon icon={faUser} color='#ffffff' />
                  <div>{t('Profile')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/appointments' title={t('Appointments')}>
                  <FontAwesomeIcon icon={faCalendarCheck} color='#ffffff' />
                  <div>{t('Appointments')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/analysis' title={t('Analysis')}>
                  <FontAwesomeIcon icon={faChartBar} color='#ffffff' />
                  <div>{t('Analysis')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/report-card-generator' title={t('Report Cards')}>
                  <FontAwesomeIcon icon={faMedal} color='#ffffff' />
                  <div>{t('Report Cards')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/market-place/new-market-place' title={t('MarketPlace')}>
                  <FontAwesomeIcon icon={faShoppingCart} color='#ffffff' />
                  <div>{t('MarketPlace')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/student-attendance-report' title={t('Attendance')}>
                  <FontAwesomeIcon icon={faWalking} color='#ffffff' />
                  <div>{t('Attendance')}</div>
                </NavLink>
              </li>
              <li>
                <NavLink activeclassname='active' to='/change-password' title={t('Change Password')}>
                  <FontAwesomeIcon icon={faKey} color='#ffffff' />
                  <div>{t('Change Password')}</div>
                </NavLink>
              </li>
            </ul>
          </div>
          <div className='logo' style={{ marginBottom: 20 }}>
            <a
              title='Educore Systems and Technologies FZE'
              href='https://ieducore.com/' target='_blank'>
              <img src={logo} alt='iEducore' />
            </a>
          </div>
        </div>
        {/* <button className='btn-chat'>
                    <span>{t('CHAT')}</span>
                    <FontAwesomeIcon
                        icon={faCommentAlt}
                        color='#00D045'
                        style={{ fontSize: 100 }}
                    />
                </button> */}
      </aside>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
});

export default connect(mapStateToProps, null)(NavBar);
